
///////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Login.jsx
 * 로그인 페이지
 */
///////////////////////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect,useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Login.css';
import '../css/Modal.css';
import Modal from 'react-modal';
import CryptoJS from 'crypto-js';
import prod from '../config/prod';  // 운영 서버 설정
import { setUserAuth } from '../auth'; // 사용자 인증 정보 저장

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const Login = () => {
    /* ------------------------ State ------------------------ */
    const [isLoading, setIsLoading] = useState(true); // 로딩 상태 (자동 로그인 처리 시 랜더링 방지)
    
    // 아이디 저장 여부
    const [savedState, setSavedState] = useState(() => {
        return localStorage.getItem('savedState') === 'true';
    });
    
    // 자동 로그인 여부
    const [autoLoginState, setAutoLoginState] = useState(() => { 
        return localStorage.getItem('autoLoginState') === 'true';
    });
    
    //const [userId, setUserId]       = useState(''); // 아이디
    // 아이디
    const [userId, setUserId]       = useState(() => {
        // 저장된 아이디가 존재하면 불러오기
        return localStorage.getItem('savedUserId') || '';
    });
    
    const [password, setPassword]   = useState(''); // 패스워드
    const [error, setError]         = useState(''); // 오류 메시지

    const navigate = useNavigate(); // 네비게이트 함수

    // 알림 모달 표시
    const [isModalOpen, setIsModalOpen]     = useState(false);
    const [modalMessage, setModalMessage]   = useState('');

    


    /* ------------------------ Handler ------------------------ */
    // 모달 표시 함수
    const showModal = (message) => {
        setModalMessage(message);
        setIsModalOpen(true);
    };




    /* ------------------------ API ------------------------ */
    // API를 호출하여 사용자 인증 처리
    const authenticateUser = async (userId, password) => {
        try {
            const URL = `${prod.SERVER}/api/user/login` // 로그인 API 호출
            
            // 로그인 계정 정보
            const loginInfo = {
                "userId"    : userId,
                "password"  : CryptoJS.SHA256(password).toString()
            };

            const response = await fetch(URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(loginInfo),
            });

            if (!response.ok) {
                throw new Error('네트워크 응답이 올바르지 않습니다.');
            }

            const data = await response.json();
            console.log("[Login.jsx] 로그인 응답 ::: ", data);

            if (data.success) {
                // 사용자 인증 정보 저장
                const userData = {
                  userId: data.userId,
                  userNo: data.userNo,
                  userName: data.name,
                  url: data.url,
                  hospitalId: data.hospitalId
                };
                
                const authResult = setUserAuth(userData);
                if (!authResult) {
                  return { success: false, message: '로그인 처리 중 오류가 발생했습니다.' };
                }
                
                return { success: true, data: userData };
              } else {
                return { success: false, message: data.message || '로그인에 실패했습니다.' };
              }
        } catch (error) {
            console.error('[Login.jsx] 로그인 실패:', error);
            return { success: false, message: '서버 오류가 발생했습니다' };
        }
    };

    

    /* ------------------------ Event ------------------------ */
    // 로그인 이벤트
    const handleLogin = async (event) => {
        event.preventDefault(); // 이벤트 기본 동작 방지
        setError(''); // 오류 메시지 초기화

        // 아이디 저장 처리
        if (savedState) {
            localStorage.setItem('savedUserId', userId);
            localStorage.setItem('savedState', 'true');
        }

        // 자동 로그인 정보 저장
        if (autoLoginState) {
            localStorage.setItem('autoLogin', 'true');
            localStorage.setItem('autoLoginData', JSON.stringify({
                userId: userId,
                password: password
            }));
        }

        try {
            const result = await authenticateUser(userId, password); // 인증 처리
            console.log("[Login.jsx] 로그인 결과 ::: ", result);

            // 별도 URL 접근 설정이 안되어 있으면 오류 메시지 표시
            /*
            if (result.data.url === null) {
                console.log("별도 URL 접근 설정이 안되어 있습니다.")
                showModal('현재 접근 권한이 없습니다. 관리자에게 문의하세요.');
                return;
            }
            */

            // 로그인 성공 시 별도 URL 접근
            if (result.success) {
                //navigate(result.data.url || '/main', { replace: true });
                setTimeout(() => {
                    //navigate('/main', { replace: true });
                    window.location.href = '/main';
                    console.log("[Login.jsx] 로그인 성공");
                }, 0);
            } else {
                showModal(result.message);
            }
        } catch (error) {
            console.error('[Login.jsx] 로그인 실패:', error);
            showModal('서버 오류가 발생했습니다');
        }
    };


    // 아이디 저장 처리
    const handleSaveId = (e) => {
        const isChecked = e.target.checked;

        setSavedState(isChecked);

        if (isChecked) {
            localStorage.setItem('savedUserId', userId);
            localStorage.setItem('savedState', 'true');
        } else {
            localStorage.removeItem('savedUserId');
            localStorage.setItem('savedState', 'false');
        }
    };


    // 자동 로그인 처리
    const handleAutoLogin = (e) => {
        const isChecked = e.target.checked;

        setAutoLoginState(isChecked);
        
        if (!isChecked) {
            localStorage.removeItem('autoLogin');
            localStorage.removeItem('autoLoginData');
        }
    };


    /* ------------------------ Effect ------------------------ */
    // 자동 로그인 처리
    useEffect(() => {
        const checkAutoLogin = async () => {
            const isAutoLogin   = localStorage.getItem('autoLogin') === 'true';
            const autoLoginData = localStorage.getItem('autoLoginData');

            if (isAutoLogin && autoLoginData) {
                try {
                    const loginData = JSON.parse(autoLoginData);
                    const result = await authenticateUser(loginData.userId, loginData.password);
                    
                    if (result.success) {
                        window.location.href = '/main';
                        return;
                    } else {
                        // 자동 로그인 실패 시 저장된 데이터 삭제
                        localStorage.removeItem('autoLogin');
                        localStorage.removeItem('autoLoginData');
                    }
                } catch (error) {
                    console.error('자동 로그인 실패:', error);
                }
            }
            setIsLoading(false);
        };

        checkAutoLogin();
    }, []);


    /* ------------------------ Render ------------------------ */
    if (isLoading) {
        // 로딩 스피너 표시
        return <div className="loading-spinner">로딩중...</div>
    } else {
        return (
            <div className="login-container">
                <form onSubmit={handleLogin}>
                    <h2>POPBIO</h2>
                    
                    <div className="form-group">
                        <label>아이디</label>
                        <input
                            type="text"
                            value={userId}
                            onChange={(e) => setUserId(e.target.value)}
                            required
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>비밀번호</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                        />
                    </div>
                    
                    <div className="login-checkbox-container">
                        <div className="save-id-container">
                            <input type="checkbox" id="saveId" checked={savedState} onChange={handleSaveId} />
                            <label htmlFor="saveId">아이디 저장</label>
                        </div>
                        <div className="auto-login-container">
                            <input type="checkbox" id="autoLogin" checked={autoLoginState} onChange={handleAutoLogin} />
                            <label htmlFor="autoLogin">로그인 상태 유지</label>
                        </div>
                    </div>
                    
                    <button type="submit" className="login-button">로그인</button>
                </form>
    
                <Modal 
                    isOpen={isModalOpen} 
                    onRequestClose={() => setIsModalOpen(false)} 
                    className="modal-content"
                >
                    <h2 className="modal-title">알림</h2>
                    <p className="modal-message">{modalMessage}</p>
                    <button className="modal-button" onClick={() => setIsModalOpen(false)}>닫기</button>
                </Modal>
            </div>
        );
    }

    
};

export default Login;